import { useMediaQuery, useTheme } from "@material-ui/core";
import { headerHeights } from "../../../config";

export const useWelcomeMessageStyle = (
  { hidingMessage } = { hidingMessage: false }
) => {
  const { palette, breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));

  const { logo } = headerHeights();

  const itemsStyle = {
    transform: hidingMessage ? "translateY(20px)" : "translateY(0px)",
    color: palette.text.title,
  };
  const circleBoxWidth = 140;
  const logoHeight = isScreenXs ? logo.mobile : logo.desktop;
  const circleLogoHeight = circleBoxWidth;
  const circleLogoWidth = circleBoxWidth;

  return {
    itemsStyle,
    circleBoxWidth,
    logoHeight,
    circleLogoHeight,
    circleLogoWidth,
  };
};
